import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AppSettingsProductsDataApiDataTable = lazy(() =>
  import("@components/AppSettingsProductsDataApiDataTable").then((module) => ({
    default: module.AppSettingsProductsDataApiDataTable,
  }))
);

export const productsNRO: NavigationRoutingObject = {
  Component: AppSettingsProductsDataApiDataTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("products-menu-option", "Products"),
  pageNameForTracking: () => "Products",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("products-description-nav", "Manage your products and their properties"),
  icon: "nav-system-products",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
